import ModuleTableData from './ModuleTableData';

export default ModuleTableData;
